module.exports = __webpack_public_path__ + "img/0021.d8646e88.jpg";